import { EntityStatusBadgeVariant } from '@frontend/common';
import { EntityStatusBadge } from '@frontend/components/badge';
import { PackageStateName } from '@frontend/package/types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ProofOutcome, getProofOutcome } from './proof-of-identity-packages.utils';

function outcomeVariant(outcome: ProofOutcome): EntityStatusBadgeVariant {
    switch (outcome) {
        case 'completed':
            return EntityStatusBadgeVariant.Completed;
        case 'failed':
            return EntityStatusBadgeVariant.Failed;
        case 'skipped':
            return EntityStatusBadgeVariant.Cancelled;
    }
}

function OutcomeLabel({ outcome }: { outcome: ProofOutcome }) {
    switch (outcome) {
        case 'completed':
            return (
                <FormattedMessage
                    id='platform.transaction.modal.proof-of-identity.outcome-completed'
                    description='Status badge when a proof-of-identity action has completed successfully'
                    defaultMessage='Completed'
                />
            );
        case 'failed':
            return (
                <FormattedMessage
                    id='platform.transaction.modal.proof-of-identity.outcome-failed'
                    description='Status badge when a proof-of-identity action has failed'
                    defaultMessage='Failed'
                />
            );
        case 'skipped':
            return (
                <FormattedMessage
                    id='platform.transaction.modal.proof-of-identity.outcome-skipped'
                    description='Status badge when a proof-of-identity action was skipped'
                    defaultMessage='Skipped'
                />
            );
    }
}

export interface PackageProofStateBadgeProps {
    state: PackageStateName;
}

/** Shows Completed / Failed / Skipped only; returns null while the action is still open. */
export const PackageProofStateBadge = ({ state }: PackageProofStateBadgeProps) => {
    const outcome = getProofOutcome(state);
    if (!outcome) return null;

    return (
        <EntityStatusBadge
            id='package-proof-state-badge'
            label={<OutcomeLabel outcome={outcome} />}
            variant={outcomeVariant(outcome)}
        />
    );
};
